import { Action, Dispatch } from 'redux';
import { PageViewModel } from '@models/common.models';
import { ContractTermSearchViewModel } from '@models/ContractHistory';
import { contractService } from '@services/ContractService';
import { CoverageOption } from '@models/CoverageOption';

export enum ContractHistoryActionType {
  /*** SearchContractTerm ***/
  SearchContractTermStart = 'SearchContractTermStart',
  SearchContractTermSuccess = 'SearchContractTermSuccess',
  SearchContractTermFailure = 'SearchContractTermFailure'
}

/************* SearchContractTerm *************/
export interface SearchContractTermStartAction extends Action {
  readonly type: ContractHistoryActionType.SearchContractTermStart;
  readonly query: string | null;
}
export interface SearchContractTermSuccessAction extends Action {
  readonly type: ContractHistoryActionType.SearchContractTermSuccess;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly orderBy: string;
  readonly result: PageViewModel<ContractTermSearchViewModel>;
}
export interface SearchContractTermFailureAction extends Action {
  readonly type: ContractHistoryActionType.SearchContractTermFailure;
  readonly error: string;
}

/************* SearchContractTerm *************/
export function searchContractTerm(
  query: string | null,
  pageSize: number,
  pageNumber: number,
  orderBy: string,
  orderByDirection: string,
  contractId?: number
) {
  return async (dispatch: Dispatch<ContractTermSearchViewModel>) => {
    dispatch(searchContractTermStart(query));
    try {
      let result: PageViewModel<ContractTermSearchViewModel> = await contractService.searchContractTerms(
        pageNumber,
        pageSize,
        orderBy,
        orderByDirection,
        query ? query : undefined,
        contractId
      );
      if (result) {
        result.results.forEach((valueCT, indexCT, arrayCT) => {
          let coverageOptions = valueCT.coverageOptions.slice();
          coverageOptions.forEach((valueCO, indexCO, arrayCO) => {
            valueCO.sellerCoverage = valueCT.seller && valueCO.sellerCoverage;
          });
          let totalPrice = coverageOptions
            .map(x => (x.priceAdjustment ? +x.price! + +x.priceAdjustment! : +x.price!) || 0)
            .reduce((a, b) => a + b, 0);
          coverageOptions.push({ value: 'TOTAL', price: totalPrice } as CoverageOption);
          valueCT.coverageOptions = coverageOptions;
        });
      }
      dispatch(searchContractTermSuccess(pageNumber, pageSize, orderBy, result!));
    } catch (e) {
      dispatch(searchContractTermFailure(e.toString()));
    }
  };
}
export function searchContractTermStart(query: string | null): SearchContractTermStartAction {
  return {
    type: ContractHistoryActionType.SearchContractTermStart,
    query: query
  };
}
export function searchContractTermSuccess(
  pageNumber: number,
  pageSize: number,
  orderBy: string,
  result: PageViewModel<ContractTermSearchViewModel>
): SearchContractTermSuccessAction {
  return {
    type: ContractHistoryActionType.SearchContractTermSuccess,
    pageNumber: pageNumber,
    pageSize: pageSize,
    orderBy: orderBy,
    result: result
  };
}
export function searchContractTermFailure(error: string): SearchContractTermFailureAction {
  return {
    type: ContractHistoryActionType.SearchContractTermFailure,
    error: error
  };
}



// WEBPACK FOOTER //
// ./src/contract/contract-history.actions.tsx